export function TickIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check w-4 h-4 inline ml-2 text-[#1a4d7c]"><path d="M20 6 9 17l-5-5" /></svg>
  );
}
